import { render, staticRenderFns } from "./ProgressoDots.vue?vue&type=template&id=55bcf1fe"
import script from "./ProgressoDots.vue?vue&type=script&lang=js"
export * from "./ProgressoDots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports